import { render, staticRenderFns } from "./ImportOpticalgymPackage.vue?vue&type=template&id=748b80ce"
import script from "./ImportOpticalgymPackage.vue?vue&type=script&lang=js"
export * from "./ImportOpticalgymPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports